import { useCallback } from 'react'
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { useNavigationStore } from '../store';

const propTypes = {}

const NavigationForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit }, collections: { list: refresh } } = useNavigationStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleClose = useCallback(() => {
    history.push('/cms/settings/navigations')
  }, [])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      await refresh()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Navigation ${message}.`)
      handleClose()
    } catch {
      handleError('Error', 'Navigation was not saved.')
    }
  }, [handleClose, handleSubmit, refresh, handleSuccess, handleError])

  if (!item) {
    return null
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
    title='Add Navigation'>
    <Helmet title='Navigation' />
    <Form data={item} onSubmit={handleSubmitAndClose} />
  </DefaultSheet>
})

NavigationForm.propTypes = propTypes;

export default function NavigationFormLayout() {
  return <NavigationForm />
}
